import { render } from "./footer.vue?vue&type=template&id=bf6da426&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=bf6da426&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bf6da426"

export default script